import { render, staticRenderFns } from "./FileBlockNew.vue?vue&type=template&id=80ab1f34&scoped=true"
import script from "./FileBlockNew.vue?vue&type=script&lang=js"
export * from "./FileBlockNew.vue?vue&type=script&lang=js"
import style0 from "./FileBlockNew.vue?vue&type=style&index=0&id=80ab1f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ab1f34",
  null
  
)

export default component.exports